import * as types from '@store/mutation-types'

// initial state
// shape: [{ id, quantity }]
const state = {
  // 表格数据
  table: [],
  // 分页参数
  pagination: {
    current_page: 1,
    per_page: 20,
    total: 0,
  },
}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {
  getPositionTable ({commit, state}, params) {
    let promised = request.alert('getPositionTable', params)
    return promised
  },
  topPosition ({commit, state}, id) {
    let promised = request.alert('topPosition', id)
    return promised
  },
  releasePosition ({commit, state}, id) {
    let promised = request.alert('releasePosition', id)
    return promised
  },
  deletePosition ({commit, state}, id) {
    let promised = request.alert('deletePosition', id)
    return promised
  },
  batchDeletePosition ({commit, state}, ids) {
    let promised = request.alert('batchDeletePosition', ids)
    return promised
  },
  batchTopPosition ({commit, state}, ids) {
    let promised = request.alert('batchTopPosition', ids)
    return promised
  },
  batchReleasePosition ({commit, state}, ids) {
    let promised = request.alert('batchReleasePosition', ids)
    return promised
  },
  getPostionForm ({commit, state}, id) {
    let promised = request.alert('getPostionForm', id)
    return promised
  },
  modifyPostion ({commit, state}, params) {
    let promised = request.alert('modifyPostion', params)
    return promised
  },
  editPostionOptions ({commit, state}) {
    let promised = request.alert('editPostionOptions')
    return promised
  },
  uploadPositionFile ({commit, state}, params) {
    let promised = request.alert('uploadPositionFile', params)
    return promised
  },
  getBatchJobTable ({commit, state}, params) {
    let promised = request.alert('getBatchJobTable', params)
    return promised
  },
  offlinePosition ({commit, state}, params) {
    let promised = request.alert('offlinePosition', params)
    return promised
  },
  batchOfflinePosition ({commit, state}, params) {
    let promised = request.alert('batchOfflinePosition', params)
    return promised
  },
  batchJobSample ({commit, state}, params) {
    let promised = request.alert('batchJobSample', params)
    return promised
  },
  batchJobDown ({commit, state}, id) {
    let promised = request.alert('batchJobDown', id)
    return promised
  },
  batchJobError ({commit, state}, id) {
    let promised = request.alert('batchJobError', id)
    return promised
  },
  forceOfflinePosition ({commit, state}, id) {
    let promised = request.alert('forceOfflinePosition', id)
    return promised
  },
  lockPosition ({commit, state}, id) {
    let promised = request.alert('lockPosition', id)
    return promised
  },
  unlockPosition ({commit, state}, id) {
    let promised = request.alert('unlockPosition', id)
    return promised
  },
  passAuditPosition ({commit, state}, id) {
    let promised = request.alert('passAuditPosition', id)
    return promised
  },
  failAuditPosition ({commit, state}, id) {
    let promised = request.alert('failAuditPosition', id)
    return promised
  },
}

// mutations
const mutations = {
  [types.SET_USER_TABLE] (state, table) {
    state.table = table
  },
  [types.SET_USER_PAGINATION] (state, pagination) {
    state.pagination.current_page = Number(pagination.current_page)
    state.pagination.per_page = Number(pagination.per_page)
    state.pagination.total = Number(pagination.total)
  },
}

export const position = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/position/position.store.js